module.exports = __webpack_public_path__ + "static/media/sudoGPRfive.0ea209a5.jpg";